import { acceptHMRUpdate, defineStore } from "pinia";
import { BazaarvoiceService } from "~/services/bazaarvoice.service";
import type { Filter, File, StoreState } from "../types/reviews.type.js";

export const useBazaarvoiceStore = defineStore({
  id: "bazaarvoice",

  state: (): StoreState => ({
    product_reviews: [],
    bazaarvoice_service: {} as BazaarvoiceService,
    review_photos: [],
    applied_filter: "submissiontime:desc",
    product_id: "11112", // Changed to string based on usage
    filter_options: [
      { name: "Most Recent", code: "submissiontime:desc" },
      { name: "Highest To Lowest", code: "Rating:desc" },
      { name: "Lowest To Highest", code: "Rating:asc" },
    ],
    question_answers: [],
    selected_photos: [],
    is_loading: false,
    bazaarvoice_api_key: useRuntimeConfig().public.bazaarvoiceApiKey,
    secondary_ratings_averages: "",
    qa_staticstics: [],
    rating_distribution: [],
    average_rating: 0,
    is_upload_loading: false,
    total_reviews: 0,
    product_detail: {},
    is_review_loading: false,
    media_error: '',
    review_form: {
      usernickname: "",
      rating: 1,
      productid: "0", 
      isrecommended: true,
      agreedtotermsandconditions: true,
      SendEmailAlertWhenPublished: true,
      title: "",
      reviewtext: "",
      rating_prestaties: 1,
      rating_eigenschappen: 1,
      rating_betrouwbaarheid_1: 1,
      rating_prijskwaliteitverhouding: 1,
      photos: [],
      videos: [],
    },
    uploaded_video:[],
    is_review_submitted: false,
    is_review_submit_loading: false,
    review_form_errors: "",
    mapped_images: [],
  }),

  actions: {
    async initialize() {
      const { initialize } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await initialize();
    },

    async setProductId(slug): Promise<void> {
      const { setProductId } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return setProductId(slug);
    },

   async setFilter(filter: Filter): Promise<void> {
      const { setFilter } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return setFilter(filter);
    },

    async addPhoto(file: File) {
      const { addPhoto } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await addPhoto(file);
    },

    async removePhoto(link: string) {
      const { removePhoto } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return removePhoto(link);
    },

     mapImages(reviews: any[]) {
      return reviews.flatMap(review => 
        review.photos.map((photo:any) => ({
          id: photo.Id,
          image: photo.Sizes.thumbnail.Url,
          desktopImage: photo.Sizes.large.Url,
        }))
      );
    },

    async addVideo(file: File) {
      const { addVideo } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await addVideo(file);
    },

    async removeVideo(link: string, id: number) {
     
      const { removeVideo } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return  removeVideo(link,id);
      
    },

    async getProductDetail(id: number) {
      const { getProductDetail } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await getProductDetail(id);
    },

    async getProductReviews(): Promise<void> {
      const { getProductReviews } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await getProductReviews();
    },

    async getFilteredReviews(options: { search?: string; rating?: number } = {}) {
      const { getFilteredReviews } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await getFilteredReviews(options);
    },

    async submitReviewFeedback(content_id: number, type: string) {
      const { submitReviewFeedback } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await submitReviewFeedback(content_id,type);
    },

    async getQuestionAnswers() {
      const { getQuestionAnswers } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await getQuestionAnswers();
    },

    async submitProductReview() {
      const { submitProductReview } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return await submitProductReview();
    },

   async resetReviewForm() {
      const { resetReviewForm } = await import('~/stores-datalayer/bazaarvoice.datalayer');
      return resetReviewForm();
    }

  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBazaarvoiceStore, import.meta.hot));
}